export default "__VITE_ASSET__B_FJZH9e__"